import { useAxios } from "utils/axiosHook";

//学校内の生徒たちの出席状況を取得
const useAttendances = () => {
  const [{ data, loading, error }, api] = useAxios<any, any, any>(
    {},
    { manual: true }
  );

  const getAttendances = (gradeId, sectionId) => {
    const params = { gradeId, sectionId };
    return api({
      url: `/attendances`,
      method: "GET",
      params: params,
    });
  };

  return { data, loading, error, getAttendances };
};

export { useAttendances };
